import React from "react";
import "./navbar.css";

const Navbar = () => {
  return (
    <nav className="navbar">

      <div className="navbar-logo">
       
      </div>

      <ul className="nav-links">
        <li>Home</li>
        <li>My Work</li>
        <li>Contact</li>
      </ul>

    </nav>
  );
};

export default Navbar;
